var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0508 4.66127H7.25056V0.460938H3.05022V4.66127H0.25L5.15039 9.56166L10.0508 4.66127ZM0.25 10.9618V12.3619H5.15039H10.0508V10.9618H0.25Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadAvatar);
export default __webpack_public_path__ + "static/media/icon_download_avatar.b01a465ec06ac934ffbf4dc47b2e2b35.svg";
export { ForwardRef as ReactComponent };